import {
  Component,
  OnInit,
  ViewContainerRef,
  Injectable,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { TeamService } from 'src/app/shared/services/team.service';
import { Position } from 'src/app/shared/models/team/position';
import { Team } from 'src/app/shared/models/team/team';
import { PositionDetailsComponent } from 'src/app/teams/position-details/position-details.component';
import { TeamEditComponent } from 'src/app/teams/team-edit/team-edit.component';
import { ModalConfirmationComponent } from 'src/shared-app-portal/components/modal-confirmation/modal-confirmation.component';
import { ResponsiveService } from 'src/app/shared/services/responsive.service';
import { AuthService } from 'src/app/auth/auth.service';
import { SurveyService } from 'src/app/shared/services/survey.service';
import { FormService } from 'src/app/shared/services/form.service';
import { TeamCloneComponent } from '../team-clone/team-clone.component';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { TenantPlanErrorModalComponent } from 'src/app/shared/components/tenant-plan-error-modal/tenant-plan-error-modal.component';
import { CustomViewColumn } from 'src/app/shared/components/odata-filter/models/custom-view-column';
import { TeamRostersReportFields } from 'src/app/reports/team-rosters-report/team-rosters-report-fields';
import { AttributeEntityType } from 'src/app/shared/models/attributes/attributeEntityType';
import { AttributeService } from 'src/app/shared/services/attribute.service';
import { ExportRequest } from 'src/app/shared/components/odata-filter/models/export-request';
import { TeamRostersReportService } from 'src/app/reports/team-rosters-report/team-rosters-report.service';
import { TEAM_ROSTERS_REPORT_FILTER_MODELS } from 'src/app/shared/components/odata-filter/models/system-filter-models';
import { SelectedFilter } from 'src/app/shared/components/odata-filter/models/selected-filter';
import { OPERATORS } from 'src/app/shared/components/odata-filter/models/operators';
import { FilterOperatorType } from 'src/app/shared/components/odata-filter/models/filter-operator-type';
import { SavedFilter } from 'src/app/shared/components/odata-filter/models/saved-filter';
import { CustomView } from 'src/app/shared/components/odata-filter/models/custom-view';
import { ViewContext } from 'src/app/shared/components/odata-filter/models/view-context';
import { HigherLogicIntegrationComponent } from '../higher-logic-integration/higher-logic-integration.component';
import { WorkspaceService } from 'src/app/shared/services/workspace.service';
import { TeamWorkspaceMigrationComponent } from '../team-workspace-migration/team-workspace-migration.component';
import { Workspace } from 'src/app/shared/models/workspace/workspace';

@Component({
  selector: 'team-header',
  templateUrl: 'team-header.component.html',
  styleUrls: ['./team-header.component.scss'],
  standalone: false
})
@Injectable()
export class TeamHeaderComponent implements OnInit, OnDestroy {
  @ViewChild('teamMigrationDialog', { static: false })
  teamMigrationDialog: TeamWorkspaceMigrationComponent;

  errorMessage: any;
  team: Team;
  cloneDialogRef: MatDialogRef<TeamCloneComponent>;
  teamDialogRef: MatDialogRef<TeamEditComponent>;
  confirmationRef: MatDialogRef<ModalConfirmationComponent>;
  migrateTeamToWorkspaceDialogRef: MatDialogRef<TeamWorkspaceMigrationComponent>;
  isDrawerOpened: boolean = true;
  drawerMode: string;
  isSurveyEnabled: boolean = false;
  hasSurveyTemplates: boolean = false;
  viewContext = ViewContext.TeamRosters;
  orgHasWorkspaces: boolean = false;
  activeWorkspaceIsOrg: boolean = false;
  currentWorkspaces: Workspace[] = [];
  subs: Subscription[] = [];

  constructor(
    private authService: AuthService,
    private formService: FormService,
    private teamService: TeamService,
    private router: Router,
    private dialog: MatDialog,
    private viewContainerRef: ViewContainerRef,
    private responsiveService: ResponsiveService,
    private location: Location,
    private surveyService: SurveyService,
    private appConfigService: AppConfigService,
    private attributeService: AttributeService,
    private teamRostersReportService: TeamRostersReportService,
    private workspaceService: WorkspaceService
  ) {}

  ngOnInit() {
    this.subs.push(
      this.formService.forms.subscribe((forms) => {
        this.hasSurveyTemplates = forms.filter((form) => form.isSurvey(false, true)).length > 0;
      }),
      this.responsiveService.toggleDrawerOpenCloseEvent.subscribe((showDrawer) => {
        this.isDrawerOpened = showDrawer;
      }),
      this.responsiveService.toggleDrawerDisplayModeEvent.subscribe((drawerMode) => {
        this.drawerMode = drawerMode;
      }),
      this.teamService.team.subscribe(
        (team) => (this.team = team),
        (error) => (this.errorMessage = <any>error)
      ),
      this.workspaceService.currentWorkspaces.subscribe((result) => {
        this.currentWorkspaces = result?.workspaces || [];
        this.orgHasWorkspaces = this.currentWorkspaces.length > 0;
      }),
      this.workspaceService.activeWorkspaceIsOrg.subscribe((isOrg) => {
        this.activeWorkspaceIsOrg = isOrg;
      })
    );

    this.isSurveyEnabled = this.surveyService.isEnabled();

    if (this.location.path().indexOf('personDetails') != -1) {
      this.responsiveService.toggleDrawerDisplayMode('person');
    } else if (this.location.path().indexOf('evaluation') != -1) {
      this.responsiveService.toggleDrawerDisplayMode('evaluation');
    } else if (this.location.path().indexOf('emailCustomization') != -1) {
      this.responsiveService.toggleDrawerDisplayMode('emailCustomization');
    } else if (this.location.path().indexOf('landingPageCustomization') != -1) {
      this.responsiveService.toggleDrawerDisplayMode('landingPageCustomization');
    } else if (this.location.path().indexOf('trackedFields') != -1) {
      this.responsiveService.toggleDrawerDisplayMode('trackedFields');
    } else if (this.location.path().indexOf('opportunity-listing') != -1) {
      this.responsiveService.toggleDrawerDisplayMode('opportunityListing');
    } else if (this.location.path().indexOf('sendReminders') != -1) {
      this.responsiveService.toggleDrawerDisplayMode('sendReminders');
    } else if (this.location.path().indexOf('sendSurveyReminder') != -1) {
      this.responsiveService.toggleDrawerDisplayMode('sendSurveyReminder');
    } else if (this.location.path().indexOf('higherLogicSettings') != -1) {
      this.responsiveService.toggleDrawerDisplayMode('higherLogicSettings');
    } else {
      this.responsiveService.toggleDrawerDisplayMode('team');
    }

    this.isDrawerOpened = this.responsiveService.isLargeScreen();
    this.responsiveService.toggleDrawerOpenClose(this.isDrawerOpened);
  }

  doesSendTeamEmailRequirePlanUpgrade(): boolean {
    return !this.appConfigService.tenant.plan.canSendTeamEmail;
  }

  openEditTeamDialog() {
    this.teamDialogRef = this.dialog.open(TeamEditComponent, {
      viewContainerRef: this.viewContainerRef
    });

    this.teamDialogRef.afterClosed().subscribe((result) => {
      this.teamDialogRef = null;
    });
  }

  openDeleteTeamDialog() {
    let component = this;
    component.openDeleteDialog('delete ' + this.team.name, function () {
      component.deleteTeam();
    });
  }

  openDeleteDialog(action: string, successCallback: any) {
    this.confirmationRef = this.dialog.open(ModalConfirmationComponent, {
      viewContainerRef: this.viewContainerRef,
      data: { action: action, delete: true }
    });

    this.confirmationRef.afterClosed().subscribe((result) => {
      if (result) {
        successCallback();
      }
      this.confirmationRef = null;
    });
  }

  deleteTeam() {
    this.teamService.deleteTeam(this.team.id).subscribe((res) => this.router.navigate(['/teams']));
  }

  openPositionDialog() {
    PositionDetailsComponent.openPositionDialog(this.dialog, this.viewContainerRef);
  }

  openCloneDialog() {
    this.cloneDialogRef = this.dialog.open(TeamCloneComponent, {
      data: this.team.id
    });

    this.cloneDialogRef.afterClosed().subscribe((teamId) => {
      if (teamId) {
        if (this.responsiveService.teamOpenedInBetaMode) {
          this.teamService.getTeamById(teamId);
          this.router.navigate(['/teams/beta/' + teamId + '/roster']);
        } else {
          this.router.navigate(['/teams/' + teamId]);
        }
      }

      this.cloneDialogRef = null;
    });
  }

  openTenantPlanDialog() {
    TenantPlanErrorModalComponent.openDialog(
      this.dialog,
      'Team Emails are not available on your plan.',
      `Team Emails let you email the members of this team directly within Lineup.  To use this feature, you'll need to upgrade your Lineup plan.`,
      true
    );
  }

  getExportRequest = (isCustomExport: boolean): ExportRequest => {
    const filter = `${TeamRostersReportFields.teamId} eq ${this.team.id} and ${TeamRostersReportFields.seatStatus} ne 'Bench'`;

    const orderby = `${TeamRostersReportFields.teamName},${TeamRostersReportFields.seatId}`;
    if (isCustomExport) {
      return {
        oDataQuery: `query/teamRosterMaxResult?$filter=${filter}&$orderby=${orderby}&$count=true`,
        columns: this.generateExportColumns()
      };
    }
    const expand = `${TeamRostersReportFields.personCustomFields},${TeamRostersReportFields.races},${TeamRostersReportFields.trackedCustomFields}`;
    return {
      oDataQuery: `query/teamroster?$filter=${filter}&$expand=${expand}&$orderby=${orderby}&$count=true`,
      columns: this.generateExportColumns()
    };
  };

  viewTeamRosterReport(teamName: string) {
    let view = new CustomView(
      {
        id: '',
        viewContext: ViewContext.TeamRosters,
        filters: [SavedFilter.parseToString(this.getTeamNameFilter(teamName))],
        quickFilterNames: [],
        isPublic: true,
        name: this.team.name + ' Roster',
        auth0UserId: '',
        columns: [
          CustomViewColumn.createSystemColumn(TeamRostersReportFields.teamName, 'Team', 0),
          CustomViewColumn.createSystemColumn('date', 'Date', 1),
          CustomViewColumn.createSystemColumn(
            TeamRostersReportFields.personFirstName,
            'Person First Name',
            2
          ),
          CustomViewColumn.createSystemColumn(
            TeamRostersReportFields.personLastName,
            'Person Last Name',
            3
          ),
          CustomViewColumn.createSystemColumn(
            TeamRostersReportFields.personEmail,
            'Person Email',
            4
          ),
          CustomViewColumn.createSystemColumn(TeamRostersReportFields.positionTitle, 'Position', 5),
          CustomViewColumn.createSystemColumn(
            TeamRostersReportFields.seatStatus,
            'Position Status',
            6
          ),
          CustomViewColumn.createSystemColumn(
            TeamRostersReportFields.invitationLink,
            'Invitation Link',
            7
          )
        ]
      },
      true,
      true
    );
    this.teamRostersReportService.applyView(view);
    this.router.navigate(['/reports/team-rosters']);
  }

  private getTeamNameFilter(teamName: string) {
    return new SelectedFilter({
      filter: TEAM_ROSTERS_REPORT_FILTER_MODELS.TeamNameFilterModel,
      filterOperator: OPERATORS.String.operators.find(
        (op) => op.displayOperator == FilterOperatorType.eq
      ),
      searchValue: teamName
    });
  }

  invitePicked() {
    let hasPicked = this.team.hasPeopleOnSeats && this.team.getPickedCount() > 0;
    if (hasPicked) {
      if (this.drawerMode == 'emailTeam' && this.isDrawerOpened) {
        this.responsiveService.toggleDrawerOpenClose(false);
      } else {
        this.responsiveService.toggleDrawerOpenClose(true);
      }

      if (this.isDrawerOpened) {
        this.responsiveService.toggleDrawerDisplayMode('sendInvites');
        this.responsiveService.teamOpenedInBetaMode
          ? this.router.navigate(['/teams/beta', this.team.id, 'roster', 'sendInvites'])
          : this.router.navigate(['/teams', this.team.id, 'sendInvites']);
      }
    }
  }

  remindInvited() {
    let invitedCount = this.team.getInvitedCount();
    let hasInvited = this.team.hasPeopleOnSeats && invitedCount > 0;
    if (hasInvited) {
      if (this.drawerMode == 'emailTeam' && this.isDrawerOpened) {
        this.responsiveService.toggleDrawerOpenClose(false);
      } else {
        this.responsiveService.toggleDrawerOpenClose(true);
      }

      if (this.isDrawerOpened) {
        this.responsiveService.toggleDrawerDisplayMode('sendReminders');
        this.responsiveService.teamOpenedInBetaMode
          ? this.router.navigate(['/teams/beta', this.team.id, 'roster', 'sendReminders'])
          : this.router.navigate(['/teams', this.team.id, 'sendReminders']);
      }
    }
  }

  get teamHasPositions(): boolean {
    return (this.team?.positions?.length ?? 0) > 0;
  }

  teamIsArchived() {
    return this.team ? this.team.isArchived : false;
  }

  canEditTeam() {
    return this.authService.managerLevelAccess;
  }

  canDeleteTeam() {
    return this.authService.ownerLevelAccess;
  }

  canMigrateTeamToWorkspace(): boolean {
    return (
      this.team &&
      this.orgHasWorkspaces &&
      this.activeWorkspaceIsOrg &&
      this.currentWorkspaces.length > 0 &&
      this.authService.ownerLevelAccess
    );
  }

  openSendEvaluation() {
    if (this.drawerMode == 'evaluation' && this.isDrawerOpened) {
      this.responsiveService.toggleDrawerOpenClose(false);
    } else {
      this.responsiveService.toggleDrawerOpenClose(true);
    }

    if (this.isDrawerOpened) {
      this.responsiveService.toggleDrawerDisplayMode('evaluation');
      this.responsiveService.teamOpenedInBetaMode
        ? this.router.navigate(['/teams/beta', this.team.id, 'roster', 'evaluation'])
        : this.router.navigate(['/teams', this.team.id, 'evaluation']);
    }
  }

  canSendSurvey(): boolean {
    return this.team && this.team.hasPeopleOnSeats && this.hasSurveyTemplates;
  }

  openSendSurvey() {
    if (this.canSendSurvey()) {
      if (this.drawerMode == 'sendSurvey' && this.isDrawerOpened) {
        this.responsiveService.toggleDrawerOpenClose(false);
      } else {
        this.responsiveService.toggleDrawerOpenClose(true);
      }

      if (this.isDrawerOpened) {
        this.responsiveService.toggleDrawerDisplayMode('sendSurvey');
        this.responsiveService.teamOpenedInBetaMode
          ? this.router.navigate(['/teams/beta', this.team.id, 'roster', 'sendSurvey'])
          : this.router.navigate(['/teams', this.team.id, 'sendSurvey']);
      }
    }
  }

  openSendTeamForm() {
    if (this.drawerMode == 'sendTeamForm' && this.isDrawerOpened) {
      this.responsiveService.toggleDrawerOpenClose(false);
    } else {
      this.responsiveService.toggleDrawerOpenClose(true);
    }

    if (this.isDrawerOpened) {
      this.responsiveService.toggleDrawerDisplayMode('sendTeamForm');
      this.responsiveService.teamOpenedInBetaMode
        ? this.router.navigate(['/teams/beta', this.team.id, 'roster', 'sendTeamForm'])
        : this.router.navigate(['/teams', this.team.id, 'sendTeamForm']);
    }
  }

  openHigherLogicSettings() {
    if (this.drawerMode == 'higherLogicSettings' && this.isDrawerOpened) {
      this.responsiveService.toggleDrawerOpenClose(false);
    } else {
      this.responsiveService.toggleDrawerOpenClose(true);
    }

    if (this.isDrawerOpened) {
      this.responsiveService.toggleDrawerDisplayMode('higherLogicSettings');
      this.responsiveService.teamOpenedInBetaMode
        ? this.router.navigate(['/teams/beta', this.team.id, 'roster', 'higherLogicSettings'])
        : this.router.navigate(['/teams', this.team.id, 'higherLogicSettings']);
    }
  }

  emailTeam() {
    if (this.team.hasPeopleOnSeats && !this.appConfigService.tenant.plan.canSendTeamEmail) {
      this.openTenantPlanDialog();
      return;
    }

    if (this.team.hasPeopleOnSeats && this.appConfigService.tenant.plan.canSendTeamEmail) {
      if (this.drawerMode == 'emailTeam' && this.isDrawerOpened) {
        this.responsiveService.toggleDrawerOpenClose(false);
      } else {
        this.responsiveService.toggleDrawerOpenClose(true);
      }

      if (this.isDrawerOpened) {
        this.responsiveService.toggleDrawerDisplayMode('emailTeam');
        this.responsiveService.teamOpenedInBetaMode
          ? this.router.navigate(['/teams/beta', this.team.id, 'roster', 'emailTeam'])
          : this.router.navigate(['/teams', this.team.id, 'emailTeam']);
      }
    }
  }

  archiveTeam() {
    this.teamService.archive(this.team.id);
  }

  unarchiveTeam() {
    this.teamService.unarchive(this.team.id);
  }

  private generateExportColumns(): CustomViewColumn[] {
    let columns: CustomViewColumn[] = [
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.personEmail, 'Email', 0),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.personName, 'Full Name', 1),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.personFirstName, 'First Name', 2),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.personLastName, 'Last Name', 3),
      CustomViewColumn.createSystemColumn(
        TeamRostersReportFields.personStatus,
        'Profile Status',
        4
      ),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.gender, 'Gender', 5),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.races, 'Race', 6),
      CustomViewColumn.createSystemColumn(
        TeamRostersReportFields.personLinkedInProfile,
        'LinkedIn Profile',
        7
      ),
      CustomViewColumn.createSystemColumn(
        TeamRostersReportFields.streetAddress1,
        'Street Address 1',
        8
      ),
      CustomViewColumn.createSystemColumn(
        TeamRostersReportFields.streetAddress2,
        'Street Address 2',
        9
      ),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.city, 'City', 10),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.state, 'State', 11),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.postalCode, 'Postal Code', 12),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.country, 'Country', 13),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.phoneNumber, 'Phone', 14),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.personJobTitle, 'Job Title', 15),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.personCompany, 'Company', 16),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.positionTitle, 'Position', 17),
      CustomViewColumn.createSystemColumn(TeamRostersReportFields.seatStatus, 'Status', 18),
      CustomViewColumn.createSystemColumn(
        TeamRostersReportFields.teamPublicName,
        'Team Public Name',
        19
      ),
      CustomViewColumn.createSystemColumn(
        TeamRostersReportFields.invitationLink,
        'Invitation Link',
        20
      )
    ];

    this.team.seatAttributes.forEach((attr) => {
      let column = new CustomViewColumn();
      column.customFieldEntityType = AttributeEntityType.Seat;
      column.customFieldId = attr.id;
      column.isCustomField = true;
      column.rank = columns.length;
      column.displayName = attr.name;

      columns.push(column);
    });

    this.attributeService.attributes.subscribe((x) => {
      let personAttr = x.filter((x) => x.entityType == AttributeEntityType.Person);
      personAttr.forEach((attr) => {
        let column = new CustomViewColumn();
        column.customFieldEntityType = AttributeEntityType.Person;
        column.customFieldId = attr.id;
        column.isCustomField = true;
        column.rank = columns.length;
        column.displayName = attr.name;

        columns.push(column);
      });
    });

    return columns;
  }

  createHigherLogicCommunity() {
    this.dialog.open(HigherLogicIntegrationComponent, {
      viewContainerRef: this.viewContainerRef
    });
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
